/** Test id for the welcome onboarding marketing opt-in checkbox. */
export const ONBOARDING_MARKETING_OPT_IN_TEST_ID =
  'onboarding-welcome-marketing-opt-in';
